var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var Transaction = require('../../transaction');

module.exports =
/*#__PURE__*/
function (_Transaction) {
  "use strict";

  _inherits(Redshift_Transaction, _Transaction);

  function Redshift_Transaction() {
    _classCallCheck(this, Redshift_Transaction);

    return _possibleConstructorReturn(this, _getPrototypeOf(Redshift_Transaction).apply(this, arguments));
  }

  _createClass(Redshift_Transaction, [{
    key: "savepoint",
    value: function savepoint(conn) {
      this.trxClient.logger('Redshift does not support savepoints.');
      return Promise.resolve();
    }
  }, {
    key: "release",
    value: function release(conn, value) {
      this.trxClient.logger('Redshift does not support savepoints.');
      return Promise.resolve();
    }
  }, {
    key: "rollbackTo",
    value: function rollbackTo(conn, error) {
      this.trxClient.logger('Redshift does not support savepoints.');
      return Promise.resolve();
    }
  }]);

  return Redshift_Transaction;
}(Transaction);